export const types = {
  changeCount: "change-count",
  priceChanged: "price",
  productDisabled: "count",
  noPrice: "no-price",
  supplierChanged: "supplier",
  disabled: "disabled",
  outStock: "out-stock",
  exchangeSuccess: "exchange_success",
  neutralSuccess: "out-stock_exchange-success",
  onRequest: "on_request",
  notAvailable: "not_available",
};

export const savingTypes = [types.noPrice, types.supplierChanged, types.priceChanged];

export const successTypes = [types.exchangeSuccess];
export const neutralTypes = [types.neutralSuccess];